export default __webpack_public_path__ + "static/media/2022-IMcover.ac4dd101.png";